export default __webpack_public_path__ + "images/9964883e0a16b2c4c2bce17b223bc0ca-x-close-large.svg";